import GoogleMapReact from "google-map-react";
// @ts-expect-error TODO(typecheck-unify): TS6133 'React' is declared but its value is never read.
import React, { useEffect, useState } from "react";
import _ from "lodash";

import { MapMarkerIcon } from "../../icons/mapMarker";
import { LA_CENTER } from "../../utils/googleMap";

// @ts-expect-error TODO(typecheck-unify): TS7031 Binding element 'location' implicitly has an 'any' type.
function AddressEditMap({ location, onChange }) {
  // FIXME: Automatically disabled during ESLint config update
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const [mapCenter, setMapCenter] = useState<any>({});
  const [markerLocation, setMarkerLocation] = useState({});

  useEffect(() => {
    setMarkerLocation(location);
    setMapCenter(location || LA_CENTER);
  }, [location]);

  // @ts-expect-error TODO(typecheck-unify): TS7031 Binding element 'center' implicitly has an 'any' type.
  const onDrag = ({ center }) => {
    setMarkerLocation({
      lat: center.lat(),
      lng: center.lng(),
    });
  };

  const onMapChange = () => {
    if (_.isEqual(location, markerLocation)) {
      return;
    }

    onChange({ ...markerLocation });
  };

  return (
    <GoogleMapReact
      defaultCenter={LA_CENTER}
      center={mapCenter}
      zoom={17}
      yesIWantToUseGoogleMapApiInternals
      onChange={onMapChange}
      onDrag={onDrag}
    >
      <MapMarkerIcon {...markerLocation} />
    </GoogleMapReact>
  );
}

export { AddressEditMap };
